export default __webpack_public_path__ + "static/Singapore-ddee91f64d3a77da049bb5d09efcef42.png";